var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9h8M8 15h5M8 21h5M22 9h2M18.523 22.085A2.961 2.961 0 0021 23.252c1.519 0 2.75-.924 2.75-2.063 0-1.138-1.231-2.062-2.75-2.062s-2.75-.924-2.75-2.064C18.25 15.923 19.48 15 21 15a2.964 2.964 0 012.477 1.167M21 23.252v1.373M21 13.627V15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31a3.473 3.473 0 016 0V1a3.485 3.485 0 01-3 1.724A3.484 3.484 0 0122 1a3.485 3.485 0 01-3 1.724A3.484 3.484 0 0116 1a3.485 3.485 0 01-3 1.724A3.484 3.484 0 0110 1a3.485 3.485 0 01-3 1.724A3.484 3.484 0 014 1v30a3.473 3.473 0 016 0 3.473 3.473 0 016 0M16 31a3.473 3.473 0 016 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTax;